import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { Product } from "../../types/types";

const initialState: Product[] = []

export const fetchProducts = createAsyncThunk(
    'fetchProducts',
    async () => {
        const responce = await axios.get('https://api.escuelajs.co/api/v1/products')
        return responce.data
    }
)

const product = createSlice({
    name: "product",
    initialState,
    reducers: {
        editProduct: (state, action: PayloadAction<Product[]>) => {
            return state.map(item => {
                let product = action.payload.find(product => product.id === item.id)
                return !!product ? product : item
            })
        }
    },
    extraReducers: (build) => {
        build
        .addCase(fetchProducts.fulfilled, (state, action)=> {
            return action.payload
        })
    }
})

export const productReducer = product.reducer
export const {editProduct} = product.actions